<section class="stepper-body">
    <header class="stepper-navigation-bar">
        @for (step of steps; track step; let i = $index; let isLast = $last) {
            <button class="step" (click)="manualClick(i)">
                <div class="stepper-number" [ngClass]="{ 'stepper-active': selectedIndex > i - 1 }">
                    <span class="center-number">{{ i + 1 }}</span>
                </div>
                {{ step.label }}
            </button>
        }
    </header>
    <hr />
    <div class="content-container">
        @for (step of steps; track step; let i = $index) {
            <div
                class="stepper-content"
                [style.display]="stepDisplay[i]"
                [@stepTransition]="_getAnimationDirection(i)"
                (@stepTransition.done)="_animationDone.next($event)"
                [attr.tabindex]="selectedIndex === i ? 0 : null"
                [id]="_getStepContentId(i)"
                [attr.aria-labelledby]="_getStepLabelId(i)"
                [attr.aria-expanded]="selectedIndex === i"
            >
                @if (selectedIndex === i || !destroyOnHide) {
                    <ng-container [ngTemplateOutlet]="step.content"> </ng-container>
                }
            </div>
        }
    </div>
</section>
